// extracted by mini-css-extract-plugin
module.exports = {"icon":"SessionProductIcon_icon__3231a"};